module.exports = __webpack_public_path__ + "img/fl_pic.dab5cdf8.png";